export const TOKEN = 'AB_STORE_TOKEN';

export const START_LOADER = 'START_LOADER';
export const STOP_LOADER = 'STOP_LOADER';

export const SET_USER = 'SET_USER';
export const REMOVE_USER = 'REMOVE_USER';

export const ADD_CART = 'ADD_CART';
export const REMOVE_CART = 'REMOVE_CART';
export const REFRESH_CART = 'REFRESH_CART';

export const SHORT_DATE = 'YYYY-MM-DD';

export const ERRORS = {
    required: 'This is a required field',
    number: 'Value must be a number',
    email: 'Value must be a email',
    lessThan: 'Value must be less than',
    greaterThan: 'Value must be greater than',
    positive: 'Value must be a positive number',
};